import TeambookTable from "../../../default_components/teambook_table";
import {getTableContentRows, getTableHeader} from "./tableHelpers";
import {useTranslation} from "react-i18next";

const HoursOverview = ({ stats, type }) => {
  const { t } = useTranslation();

  const headerRows = getTableHeader(type, t);
  const contentRows = getTableContentRows(stats.map(s => s.hours_overview), type);

  const figuresText = () => {
    return {
      default: t("dashboard.overview_figures_default"),
      actuals: t("dashboard.overview_figures_default"),
      capacity: t("dashboard.overview_figures_days"),
      compare: t("dashboard.overview_figures_default")
    }[type]
  }

  return (
    <div className="analytics__hours-overview">
      <div className="analytics__hours-overview__legend">
        <p>{t("dashboard.overview")}</p>
        <p className="sub-text">{figuresText()}</p>
      </div>

      <TeambookTable
        headerRows={headerRows}
        contentRows={contentRows}
      />
    </div>
  )
}

export default HoursOverview;
